import { Component, Input } from '@angular/core';
import { Channel, Order, Origin } from 'src/app/core/orders.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-shared-order-origin',
  templateUrl: './shared-order-origin.component.html',
  styleUrls: ['./shared-order-origin.component.scss'],
})
export class SharedOrderOriginComponent {
  @Input() order?: Order;
  @Input() show_label: boolean = true;
  in_store_origin: Origin = Origin.in_store;
  web_origin: Origin = Origin.web;
  off_session_channel: Channel = Channel.off_session;
  on_session_channel: Channel = Channel.on_session;

  constructor(private utils_service: UtilsService) {}

  getOriginLabel(origin?: Origin, channel?: Channel): string {
    return this.utils_service.getOriginLabel(origin, channel);
  }
}
